
import blogPostsQuery from "~/apollo/queries/blog/posts.gql";
import blogQuery from "@/apollo/queries/pages/blog.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';
import seoMixin from '@/mixins/seoMixin';
import {i18nPages} from "@/i18n.config.js";

export default {
  name: 'blog',
  colorMode: 'dark',
  mixins: [lenisScrollMixin, previewModeMixin, seoMixin],
  data() {
    return {
      blog: null,
      blogPosts: null,
      i18nPages,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const responseBlog = await app.apolloProvider.defaultClient.query({
      query: blogQuery,
      variables: {
        locale: app.i18n?.locale || 'en',
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const blog = responseBlog.data.blog;
    const responseBlogPosts = await app.apolloProvider.defaultClient.query({
      query: blogPostsQuery,
      variables: {
        locale: app.i18n?.locale || 'en',
        publicationState: previewMode ? "PREVIEW" : "LIVE"
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const blogPosts = responseBlogPosts.data.blogPosts;

    return {
      blog,
      blogPosts
    };
  },
  computed: {
    // Check if the current route is a category page
    isCategoryPage() {
      return this.$route.name === 'blog-topics-slug';
    },
    // Get the current category slug from the route params
    currentCategorySlug() {
      return this.$route.params.slug || null;
    },
    categories() {
      const categoriesSet = [];
      if (this.blogPosts?.data) {
        this.blogPosts.data.forEach((post) => {
          post.attributes.blog_categories.data.forEach((category) => {
            const slug = category.attributes.slug;
            const title = category.attributes.title;
            if (!categoriesSet.find((cat) => cat.slug === slug)) {
              categoriesSet.push({slug, title});
            }
          });
        });
      }
      return categoriesSet.sort((a, b) => a.title.localeCompare(b.title));
    },
  },
  methods: {
    getPageData() {
      return this.blog?.data;
    },
  },
}
